<template>
  <div class="customer-profile" v-loading="loading">
    <template v-if="profile">
      <!-- 标签区 -->
      <div class="section">
        <div class="section-title">客户标签</div>
        <tag-input
          :tags="currentTags"
          :vid="vid"
          :userID="userID"
          @add="onAddTag"
          @remove="onRemoveTag">
        </tag-input>
      </div>

      <!-- 阶段 -->
      <div class="section">
        <div class="section-title">客户阶段</div>
        <el-tag :type="stageType" size="medium">{{ stageLabel }}</el-tag>
        <span class="stage-tip">{{ stageTip }}</span>
      </div>

      <!-- 会话统计 -->
      <div class="section" v-if="profile.conversationStats">
        <div class="section-title">会话统计</div>
        <el-row :gutter="12">
          <el-col :span="8">
            <div class="stat-card">
              <div class="stat-num">{{ profile.conversationStats.totalMessages }}</div>
              <div class="stat-label">消息总数</div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="stat-card">
              <div class="stat-num">{{ formatTime(profile.conversationStats.lastMsgTime) }}</div>
              <div class="stat-label">最后活跃</div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="stat-card">
              <div class="stat-num">{{ formatTime(profile.conversationStats.firstContactTime) }}</div>
              <div class="stat-label">首次联系</div>
            </div>
          </el-col>
        </el-row>
      </div>

      <!-- 事件时间线 -->
      <div class="section" v-if="profile.timeline && profile.timeline.length > 0">
        <div class="section-title">事件时间线</div>
        <el-timeline>
          <el-timeline-item
            v-for="(item, index) in profile.timeline"
            :key="index"
            :timestamp="formatTime(item.time)"
            :type="item.event.includes('删除') || item.event.includes('拉黑') ? 'danger' : 'primary'">
            {{ item.event }}{{ item.detail ? '：' + item.detail : '' }}
          </el-timeline-item>
        </el-timeline>
      </div>

      <!-- 跟进提醒 -->
      <div class="section">
        <el-button icon="el-icon-bell" size="small" type="warning" @click="showReminder = true">
          设置跟进提醒
        </el-button>
        <reminder-dialog
          :visible.sync="showReminder"
          :vid="vid"
          :userID="userID"
          :contact-name="contactName"
          @close="showReminder = false"
          @saved="onReminderSaved">
        </reminder-dialog>
      </div>
    </template>
    <el-empty v-else description="点击客户查看详情"></el-empty>
  </div>
</template>

<script>
import TagInput from './TagInput.vue'
import ReminderDialog from './ReminderDialog.vue'
import { addContactTag, removeContactTag } from '../../api/user.js'

export default {
  name: 'CustomerProfile',
  components: { TagInput, ReminderDialog },
  props: {
    profile: { type: Object, default: null },
    vid: { type: String, default: '' },
    userID: { type: String, default: '' },
    contactName: { type: String, default: '' },
    loading: { type: Boolean, default: false }
  },
  emits: ['tag-changed'],
  data() {
    return {
      showReminder: false
    }
  },
  computed: {
    currentTags() {
      if (!this.profile || !this.profile.contact) return [];
      const t = this.profile.contact.tags;
      if (!t || t === '[]' || t === '') return [];
      try { return JSON.parse(t); } catch (e) { return []; }
    },
    stageLabel() {
      const m = { new: '新客户', active: '活跃', silent: '沉默', churned: '流失' };
      return m[this.profile?.contact?.stage] || '未知';
    },
    stageType() {
      const m = { new: 'success', active: '', silent: 'warning', churned: 'danger' };
      return m[this.profile?.contact?.stage] || 'info';
    },
    stageTip() {
      const m = {
        new: '7天内新添加，建议尽快建立联系',
        active: '7天内有互动，保持跟进节奏',
        silent: '7-30天未互动，建议主动触达',
        churned: '已流失或超过30天未互动'
      };
      return m[this.profile?.contact?.stage] || '';
    }
  },
  methods: {
    formatTime(ts) {
      if (!ts || ts === 0) return '-';
      const d = new Date(ts * 1000);
      const m = d.getMonth() + 1;
      const day = d.getDate();
      return m + '/' + day;
    },
    async onAddTag({ tag }) {
      try {
        await addContactTag({ vid: this.vid, userID: this.userID, tag });
        this.$message.success('标签已添加');
        this.$emit('tag-changed');
      } catch (e) {
        this.$message.error('添加失败');
      }
    },
    async onRemoveTag({ tag }) {
      try {
        await removeContactTag({ vid: this.vid, userID: this.userID, tag });
        this.$message.success('标签已移除');
        this.$emit('tag-changed');
      } catch (e) {
        this.$message.error('移除失败');
      }
    },
    onReminderSaved() {
      this.$emit('tag-changed');
    }
  }
}
</script>

<style lang="scss" scoped>
.customer-profile {
  padding: 12px 0;
}
.section {
  margin-bottom: 16px;
}
.section-title {
  font-size: 13px;
  font-weight: 600;
  color: #606266;
  margin-bottom: 6px;
  padding-bottom: 4px;
  border-bottom: 1px solid #ebeef5;
}
.stage-tip {
  font-size: 12px;
  color: #909399;
  margin-left: 8px;
}
.stat-card {
  text-align: center;
  background: #f5f7fa;
  border-radius: 6px;
  padding: 8px 4px;
}
.stat-num {
  font-size: 16px;
  font-weight: 700;
  color: #303133;
}
.stat-label {
  font-size: 11px;
  color: #909399;
  margin-top: 2px;
}
</style>
